import { Component } from 'react';
import { SPage } from 'servisofts-component';
import ListaCajas2 from './ListaCajas/ListaCajas2';

export default class CajasPage2 extends Component {
  static navigationOptions = {
    headerShown: false,
  }
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <SPage title="Historico de cajas" disableScroll >
        <ListaCajas2 navigation={this.props.navigation} />
      </SPage>
    );
  }
}
